import { Droplets } from 'lucide-react';
import { Slider } from '@/components/ui/slider';
import { normalizeHostOverlayOpacity } from '@/lib/videoEditorHostOverlays';

/** Cyan/teal accent — distinct from timeline volume bars (white). */
export const HOST_OVERLAY_OPACITY_ACCENT = '#22d3ee';

/**
 * Vertical opacity control for host overlay images (volume-bar layout, cyan tone).
 */
export default function HostOverlayOpacityBar({
  opacity = 1,
  onOpacityChange,
  testId = 'host-overlay-opacity-bar',
}) {
  const pct = Math.round(normalizeHostOverlayOpacity(opacity) * 100);

  return (
    <div
      className="flex flex-col items-center justify-center gap-0.5 shrink-0 rounded-md border border-cyan-400/40 bg-black/65 py-1 px-0.5 pointer-events-auto shadow-lg backdrop-blur-[2px]"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
      data-testid={testId}
      title="Overlay opacity"
    >
      <Droplets className="h-2.5 w-2.5 opacity-90" style={{ color: HOST_OVERLAY_OPACITY_ACCENT }} aria-hidden />
      <Slider
        orientation="vertical"
        value={[pct]}
        min={5}
        max={100}
        step={1}
        className={[
          'h-16 w-5',
          '[&>span]:bg-cyan-400/25',
          '[&>span>span]:bg-cyan-400',
          '[&_[role=slider]]:border-cyan-300/70',
          '[&_[role=slider]]:bg-cyan-50',
        ].join(' ')}
        data-testid={testId ? `${testId}-slider` : undefined}
        onValueChange={([v]) => {
          onOpacityChange?.(normalizeHostOverlayOpacity((Number(v) || 100) / 100));
        }}
      />
      <span
        className="text-[8px] font-semibold tabular-nums leading-none"
        style={{ color: HOST_OVERLAY_OPACITY_ACCENT }}
      >
        {pct}
      </span>
    </div>
  );
}
